import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/worried-girl.svg'


const _hoisted_1 = {
  id: "modal-plugin-not-executing",
  class: "modal modal-md fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body py-3" }
const _hoisted_5 = { class: "fs-6 text-center mt-4" }
const _hoisted_6 = {
  href: "../faq/digital-certificate-plugin",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "link ms-2"
}
const _hoisted_7 = { class: "contact-wrapper" }
const _hoisted_8 = { class: "contact py-3" }
const _hoisted_9 = { class: "contact-item" }

import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'
  import { useAR } from '@/store/Pinia/useAR.store'
  import { useModalControl } from '../store/pinia/useModalControl.store'
  import usePluginDownloadModal from '../composables/usePluginDownloadModal'

  import { ref, onMounted } from 'vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ModalPluginNotExecuting',
  setup(__props, { expose: __expose }) {

  const modalControlStore = useModalControl()
  const { showPluginDownloadModal, hidePluginDownloadModal } =
    usePluginDownloadModal()

  const modal = ref<InstanceType<typeof Modal> | null>(null)
  const arStore = useAR()

  onMounted(() => {
    modal.value = new Modal('#modal-plugin-not-executing', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function verifyPluginAgain() {
    modalControlStore.show({
      modalId: 'pluginDownloadModal',
      show: showPluginDownloadModal,
      hide: hidePluginDownloadModal,
    })
  }

  __expose({ show, hide })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", { class: "modal-header pb-3" }, [
          _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Atenção!", -1)),
          _createElementVNode("button", {
            class: "btn-close",
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: hide
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("img", {
            alt: "sucesso",
            src: _imports_0
          }, null, -1)),
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "fs-6 text-start mt-4" }, [
            _createElementVNode("strong", null, "Parece que o plugin não está em execução em seu computador.")
          ], -1)),
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "fs-6 text-start mt-4" }, " Para emitir seu Certificado, certifique-se de que ele está em execução. ", -1)),
          _createElementVNode("p", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Não sabe executar o plugin?", -1)),
            _createElementVNode("a", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "me-2" }, "Clique aqui", -1)),
              _createVNode(IconComponent, { name: "up-right-from-square" })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "contact-item" }, [
                _createElementVNode("span", { class: "color--primary fw-600" }, " Ficou alguma dúvida? ")
              ], -1)),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(IconComponent, {
                  class: "icon mx-1",
                  name: "phone"
                }),
                _createElementVNode("span", null, _toDisplayString(_unref(arStore).$state.arData.foneAR), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", { class: "modal-footer py-3" }, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: verifyPluginAgain
          }, " Tentar novamente ")
        ])
      ])
    ])
  ]))
}
}

})